import _ from "lodash";

import Stack from "components/Stack";

import NoProformaUploaded from "entities/Memo/components/Sections/NoProformaUploaded";
import { IMemoSection } from "entities/Memo/sdk";
import { useRentalDataManager } from "entities/Memo/utils";
import ProfromaUnitMixAndRent from "entities/Proforma/components/ProfromaUnitMixAndRent";

import PrintableSectionSummary from "../PrintableSectionSummary";

interface IPrintableSectionUnitMixAndRent {
  dealId: number;
  externalToken?: string;
  section?: IMemoSection;
}

const PrintableSectionUnitMixAndRent = ({
  dealId,
  externalToken,
  section,
}: IPrintableSectionUnitMixAndRent) => {
  const { data: rentalIncomeData } = useRentalDataManager({
    token: externalToken,
    dealId,
  });

  return (
    <>
      {rentalIncomeData &&
      !_.isEmpty(
        rentalIncomeData.rental_data.new_unit_mix_and_rent_and_floor_area
      ) ? (
        <Stack spacing={2} data-testid="unit-mix-and-rent-section">
          <Stack justifyContent="space-between" spacing={4}>
            <ProfromaUnitMixAndRent rentalIncomeData={rentalIncomeData} />
            <PrintableSectionSummary
              title="Unit Mix &amp; Rent description"
              category="Unit Descriptions"
              dealId={dealId}
              externalToken={externalToken}
            />
          </Stack>
        </Stack>
      ) : (
        <NoProformaUploaded title="Unit Mix &amp; Rent" />
      )}
    </>
  );
};

export default PrintableSectionUnitMixAndRent;
